import { editHtml } from '@/utils/htmlUtils';

export interface TwoColumnTextCollapsableBlockViewModel {
  BackgroundTitle: string;
  Title: string;
  LeftColumnText: string;
  RightColumnText: string;
}

export const convert = (
  fromBackend: TwoColumnTextCollapsableBlockViewModel,
): TwoColumnTextCollapsableBlockViewModel => {
  const props: TwoColumnTextCollapsableBlockViewModel = {
    Title: fromBackend.Title,
    BackgroundTitle: fromBackend.BackgroundTitle,
    RightColumnText: editHtml(fromBackend.RightColumnText, [], false),
    LeftColumnText: editHtml(fromBackend.LeftColumnText, [], false),
  };
  return props;
};
